// extracted by mini-css-extract-plugin
module.exports = {"contentsArea":"App_contentsArea__nRfzi"};